import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";

function FirmaElectronica({ documento, documentoId, solicitudId, onFirmado }) {
  const [fileBase64, setFileBase64] = useState(null);
  const [algorithm] = useState("SHA256withRSA");
  const [format] = useState("PAdES");
  const [showModal, setShowModal] = useState(false);
  const [isSigned, setIsSigned] = useState(false);
  const [signedData, setSignedData] = useState("");
  const [nombreDocumento, setNombreDocumento] = useState("");
  const [descripcionSolicitud, setDescripcionSolicitud] = useState("");
  const userId = localStorage.getItem("id");
  const userRol = localStorage.getItem("rol");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const iniciarAutoScript = () => {
      if (window.AutoScript) {
        window.AutoScript.cargarAppAfirma();
      } else {
        setTimeout(iniciarAutoScript, 500);
      }
    };
    iniciarAutoScript();
  }, []);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNombreDocumento(file.name);
      const reader = new FileReader();
      reader.onload = () => setFileBase64(reader.result.split(",")[1]);
      reader.readAsDataURL(file);
    }
  };

  const signDocument = (documentToSign) => {
    if (!documentToSign) {
      alert("No hay documento para firmar.");
      return;
    }
    setLoading(true);
    const extraParams = [
      "signaturePositionOnPageLowerLeftX=100\nsignaturePositionOnPageLowerLeftY=100\nsignaturePositionOnPageUpperRightX=400\nsignaturePositionOnPageUpperRightY=200\nsignaturePage=1\nsigningReason=Aprobación"
    ].join("&");

    try {
      window.AutoScript.sign(
        documentToSign,
        algorithm,
        format,
        extraParams,
        async (signedData) => {
          setSignedData(signedData);
          setShowModal(true);
          setLoading(false);
        },
        (type, message) => {
          console.error("Error al firmar:", message);
          alert("Error al firmar: " + message);
          setLoading(false);
        }
      );
    } catch (e) {
      console.error("Error al invocar AutoScript para firmar:", e);
      setLoading(false);
    }
  };

  const sendDocument = async () => {
    const now = new Date();
    const fechaHora = now.toISOString().split("T").join(" ").split("Z")[0];
    const documentData = {
      NombreDocumento: "signed_" + nombreDocumento,
      Documento: signedData,
      usuario_id: userId,
      FechaSubida: fechaHora,
      FirmadoUser: true,
    };

    try {
      const response = await fetch("https://sectorb12.info/api/documentos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(documentData),
      });

      if (response.ok) {
        const result = await response.json();
        sendSolicitud(result.DocumentoID);
      } else {
        alert("Error al guardar el documento.");
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
    }
  };

  const sendSolicitud = async (docId) => {
    const now = new Date();
    const fechaHora = now.toISOString().split("T").join(" ").split("Z")[0];
    const solicitudData = {
      UsuarioID: userId,
      DocumentoID: docId,
      Estado: "pendiente",
      FirmadoUser: true,
      Descripcion: descripcionSolicitud,
      FechaSolicitud: fechaHora,
    };

    try {
      const response = await fetch("https://sectorb12.info/api/solicitudes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(solicitudData),
      });

      if (response.ok) {
        alert("Solicitud creada correctamente.");
        setIsSigned(true);
        setShowModal(false);
        setFileBase64(null);
        setNombreDocumento("");
        setDescripcionSolicitud("");
        setSignedData("");
        const fileInput = document.getElementById("archivo");
        if (fileInput) fileInput.value = "";
        if (typeof onFirmado === "function") onFirmado();
      } else {
        alert("Error al guardar la solicitud.");
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
    }
  };

  const updateSolicitud = async () => {
    try {
      const response = await fetch(
        `https://sectorb12.info/api/solicitudes/${solicitudId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            FirmadoAdmin: true,
            FirmadoUser: true,
            Documentos: signedData,
            NombreDocumento: "signed_" + nombreDocumento,
          }),
        }
      );

      if (response.ok) {
        alert("La solicitud ha sido actualizada y el documento firmado.");
        setIsSigned(true);
        if (typeof onFirmado === "function") onFirmado();
      } else {
        alert("Error al actualizar la solicitud.");
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
    }
    setShowModal(false);
  };

  return (
    <div>
      <Modal show={loading} centered backdrop="static">
        <Modal.Body className="text-center">
          <Spinner animation="border" role="status" />
          <p className="mt-3">Cargando Firma Electrónica...</p>
        </Modal.Body>
      </Modal>

      {userRol === "usuario" && (
        <>
          <Form.Group controlId="archivo">
            <Form.Label>Añadir archivo</Form.Label>
            <Form.Control
              type="file"
              accept=".pdf"
              onChange={handleFileUpload}
            />
          </Form.Group>
          <Form.Group controlId="descripcionSolicitud" className="mt-4">
            <Form.Label>Descripción de la solicitud</Form.Label>
            <Form.Control
              as="textarea"
              className="mb-3"
              rows={4}
              placeholder="Escribe la descripción aquí..."
              value={descripcionSolicitud}
              onChange={(e) => setDescripcionSolicitud(e.target.value)}
            />
          </Form.Group>
        </>
      )}

      <div>
        <Button
          variant="success"
          className="w-100"
          disabled={isSigned}
          onClick={() => {
            const documentToSign = userRol === "admin" ? documento : fileBase64;
            signDocument(documentToSign);
          }}
        >
          <i className="bi bi-pencil-square me-2"></i>
          <small>{isSigned ? "Enviado" : "Firmar y Enviar"}</small>
        </Button>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Firma completada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          El documento se ha firmado correctamente. Pulse enviar para proceder a su envío.
        </Modal.Body>
        <Modal.Footer>
          {userRol === "admin" && signedData && (
            <Button variant="success" onClick={updateSolicitud}>
              Actualizar Solicitud
            </Button>
          )}
          {userRol === "usuario" && (
            <Button variant="primary" onClick={sendDocument}>
              Enviar
            </Button>
          )}
          <Button variant="danger" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FirmaElectronica;